import { Map } from 'immutable';

export function buildError(message = 'unknown error') {
  return Map({
    show: true,
    message,
  });
}
